export const EMBEDDED_CONFLUENCE_ISSUE_VIEW_CROSS_JOIN_EXPERIMENT_KEY_AA =
	'platform_embed-conf_jira-issue_cross-join_exp_aa';
export const EMBEDDED_CONFLUENCE_ISSUE_VIEW_CROSS_JOIN_EXPERIMENT_KEY =
	'platform_embed-conf_jira-issue_cross-join_exp';

export const EMBEDDED_CONFLUENCE_ISSUE_VIEW_LINKED_PAGE_CROSS_JOIN_EXPERIMENT_KEY =
	'platform_embed-conf_bento_linked_crossjoin_exp';
export const EMBEDDED_CONFLUENCE_ISSUE_VIEW_LINKED_PAGE_CROSS_JOIN_EXPERIMENT_KEY_AA =
	'platform_embed-conf_bento_linked_crossjoin_exp_aa';

export const EMBEDDED_CONFLUENCE_ISSUE_VIEW_DEFER_SPACE_SELECTION_KEY =
	'platform_embed_conf_jira-issue_co-use_exp';

export const EMBEDDED_CONFLUENCE_ISSUE_VIEW_CREATE_CONFLUENCE_CONTENT_CROSS_FLOW_KEY =
	'jira_create_confluence_content_crossflow';
export const EMBEDDED_CONFLUENCE_ISSUE_VIEW_CREATE_CONFLUENCE_CONTENT_CROSS_FLOW_KEY_AA =
	'jira_create_confluence_content_crossflow_aa';

export const COHORT = 'cohort';
export const NOT_ENROLLED_COHORT = 'not-enrolled';
export const EXPERIMENT_COHORT = 'experiment';
export const CONTROL_COHORT = 'control';
